/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { EstadoActividad } from '../model/estadoActividad';
import { EstadoEvento } from '../model/estadoEvento';
import { EstadoReserva } from '../model/estadoReserva';
import { Favorite } from '../model/favorite';
import { FavoriteType } from '../model/favoriteType';
import { KoguiActividad } from '../model/koguiActividad';
import { KoguiEmpresa } from '../model/koguiEmpresa';
import { KoguiEvento } from '../model/koguiEvento';
import { KoguiReservaPatch } from '../model/koguiReservaPatch';
import { KoguiReservasQueryType } from '../model/koguiReservasQueryType';
import { KoguiSearch } from '../model/koguiSearch';
import { KoguiSearchCreated } from '../model/koguiSearchCreated';
import { KoguiSearchRequest } from '../model/koguiSearchRequest';
import { Opinion } from '../model/opinion';
import { OpinionNew } from '../model/opinionNew';
import { PhoneCountryInfo } from '../model/phoneCountryInfo';
import { ProgramacionActividad } from '../model/programacionActividad';
import { Reserva } from '../model/reserva';
import { ReservaBase } from '../model/reservaBase';
import { TipoDestinoDeOpinion } from '../model/tipoDestinoDeOpinion';
import { TipoReserva } from '../model/tipoReserva';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class KoguiService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * Elimina una opinion de un usuario sobre un destino.
     * Elimina una opinion de un usuario sobre un destino.
     * @param usuario El usuario de kogui.
     * @param tipoDestino El usuario de kogui.
     * @param destino El id del destino.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling deleteKoguiByUsuarioByDestino.');
        }
        if (tipoDestino === null || tipoDestino === undefined) {
            throw new Error('Required parameter tipoDestino was null or undefined when calling deleteKoguiByUsuarioByDestino.');
        }
        if (destino === null || destino === undefined) {
            throw new Error('Required parameter destino was null or undefined when calling deleteKoguiByUsuarioByDestino.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/opiniones/${encodeURIComponent(String(tipoDestino))}/${encodeURIComponent(String(destino))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimna nueva entrada en la lista de favoritos.
     * Elimina Favorito
     * @param usuario El usuario de kogui.
     * @param type El tipo del favorito
     * @param id El id del favorito
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling deleteKoguiByUsuarioFavoritosByTypeById.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling deleteKoguiByUsuarioFavoritosByTypeById.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteKoguiByUsuarioFavoritosByTypeById.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/${encodeURIComponent(String(type))}/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * La lista de actividades para un usuario en especifico.
     * Las Actividades.
     * @param actividadId El id de una actividad asociado a la empresa.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiActividadById(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<KoguiActividad>;
    public getKoguiActividadById(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<KoguiActividad>>;
    public getKoguiActividadById(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<KoguiActividad>>;
    public getKoguiActividadById(actividadId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getKoguiActividadById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<KoguiActividad>(`${this.configuration.basePath}/kogui/actividades/${encodeURIComponent(String(actividadId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * La lista de programaciones para una actividad especifica.
     * Las Actividades.
     * @param actividadId El id de una actividad asociado a la empresa.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProgramacionActividad>>;
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProgramacionActividad>>>;
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProgramacionActividad>>>;
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getKoguiActividadByIdProgamaciones.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<ProgramacionActividad>>(`${this.configuration.basePath}/kogui/actividades/${encodeURIComponent(String(actividadId))}/programaciones/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene una foto de actividad identificada por id.
     * Obtiene una foto de actividad del id dado.
     * @param fotoId El id de la foto.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiActividadeFotosById(fotoId: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getKoguiActividadeFotosById(fotoId: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getKoguiActividadeFotosById(fotoId: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getKoguiActividadeFotosById(fotoId: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (fotoId === null || fotoId === undefined) {
            throw new Error('Required parameter fotoId was null or undefined when calling getKoguiActividadeFotosById.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'image/_*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/kogui/actividades/fotos/${encodeURIComponent(String(fotoId))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de actividades paginadas. por defecto se ordenan en orden descendiente de creacion.
     * Al obtener las actividadesd puede especificar una paginacion y orden para mostrarlo.
     * @param xFcmtoken 
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param estado Especifica el estado a buscar.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiActividades(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoActividad, observe?: 'body', reportProgress?: boolean): Observable<Array<KoguiActividad>>;
    public getKoguiActividades(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoActividad, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<KoguiActividad>>>;
    public getKoguiActividades(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoActividad, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<KoguiActividad>>>;
    public getKoguiActividades(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoActividad, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }
        if (estado !== undefined && estado !== null) {
            queryParameters = queryParameters.set('estado', <any>estado);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<KoguiActividad>>(`${this.configuration.basePath}/kogui/actividades/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lee una opinion de un usuario sobre un destino.
     * Lee una opinion de un usuario sobre un destino.
     * @param usuario El usuario de kogui.
     * @param tipoDestino El usuario de kogui.
     * @param destino El id del destino.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Opinion>;
    public getKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Opinion>>;
    public getKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Opinion>>;
    public getKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioByDestino.');
        }
        if (tipoDestino === null || tipoDestino === undefined) {
            throw new Error('Required parameter tipoDestino was null or undefined when calling getKoguiByUsuarioByDestino.');
        }
        if (destino === null || destino === undefined) {
            throw new Error('Required parameter destino was null or undefined when calling getKoguiByUsuarioByDestino.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Opinion>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/opiniones/${encodeURIComponent(String(tipoDestino))}/${encodeURIComponent(String(destino))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene una lista de favoritos por tipo.
     * Get Favoritos por tipo.
     * @param usuario El usuario de kogui.
     * @param xFcmtoken 
     * @param target Especifica que se desea obtener el target del favorito.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioFavoritosAll(usuario: string, xFcmtoken?: string, target?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Favorite>>;
    public getKoguiByUsuarioFavoritosAll(usuario: string, xFcmtoken?: string, target?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Favorite>>>;
    public getKoguiByUsuarioFavoritosAll(usuario: string, xFcmtoken?: string, target?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Favorite>>>;
    public getKoguiByUsuarioFavoritosAll(usuario: string, xFcmtoken?: string, target?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioFavoritosAll.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (target !== undefined && target !== null) {
            queryParameters = queryParameters.set('target', <any>target);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Favorite>>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/all/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene una lista de favoritos por tipo.
     * Get Favoritos por tipo.
     * @param usuario El usuario de kogui.
     * @param type El tipo del favorito
     * @param xFcmtoken 
     * @param target Especifica que se desea obtener el target del favorito.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioFavoritosByType(usuario: string, type: FavoriteType, xFcmtoken?: string, target?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Favorite>>;
    public getKoguiByUsuarioFavoritosByType(usuario: string, type: FavoriteType, xFcmtoken?: string, target?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Favorite>>>;
    public getKoguiByUsuarioFavoritosByType(usuario: string, type: FavoriteType, xFcmtoken?: string, target?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Favorite>>>;
    public getKoguiByUsuarioFavoritosByType(usuario: string, type: FavoriteType, xFcmtoken?: string, target?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioFavoritosByType.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getKoguiByUsuarioFavoritosByType.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (target !== undefined && target !== null) {
            queryParameters = queryParameters.set('target', <any>target);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Favorite>>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/${encodeURIComponent(String(type))}/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene informacion sobre un favorito.
     * Obtien informacion sobre un favorito.
     * @param usuario El usuario de kogui.
     * @param type El tipo del favorito
     * @param id El id del favorito
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Favorite>;
    public getKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Favorite>>;
    public getKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Favorite>>;
    public getKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioFavoritosByTypeById.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getKoguiByUsuarioFavoritosByTypeById.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getKoguiByUsuarioFavoritosByTypeById.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Favorite>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/${encodeURIComponent(String(type))}/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene las reservas de un usuario.
     * Las reservas de un usuario.
     * @param usuario El usuario de kogui.
     * @param xFcmtoken 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $type 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioReservas(usuario: string, xFcmtoken?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $type?: KoguiReservasQueryType, observe?: 'body', reportProgress?: boolean): Observable<Array<Reserva>>;
    public getKoguiByUsuarioReservas(usuario: string, xFcmtoken?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $type?: KoguiReservasQueryType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Reserva>>>;
    public getKoguiByUsuarioReservas(usuario: string, xFcmtoken?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $type?: KoguiReservasQueryType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Reserva>>>;
    public getKoguiByUsuarioReservas(usuario: string, xFcmtoken?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $type?: KoguiReservasQueryType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($type !== undefined && $type !== null) {
            queryParameters = queryParameters.set('$type', <any>$type);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Reserva>>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la reservas de un usuario.
     * La reservas de un usuario.
     * @param usuario El usuario de kogui.
     * @param reservaId El id de una reserva asociado al usuario.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public getKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public getKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public getKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioReservasById.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling getKoguiByUsuarioReservasById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Reserva>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/${encodeURIComponent(String(reservaId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene informacion para la busqueda de la app. MAnejando por paginas la consulta de eventos y actividades.
     * Obtiene informacion para la busqueda de la app. MAnejando por paginas la consulta de eventos y actividades.
     * @param searchId el searchId.
     * @param xFcmtoken 
     * @param $page Especifica la pagina de eventos y actividades a obtener.
     * @param $sizeEventos Especifica el numero de eventos por pagina.
     * @param $sizeActividades ESpecifica el numero de actividades por pagina.
     * @param $user Especifica el usuario de kogui.
     * @param $extendExpiration Especifica si desea extendr la expiracion.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiDashboard(searchId: string, xFcmtoken?: string, $page?: number, $sizeEventos?: number, $sizeActividades?: number, $user?: string, $extendExpiration?: boolean, observe?: 'body', reportProgress?: boolean): Observable<KoguiSearch>;
    public getKoguiDashboard(searchId: string, xFcmtoken?: string, $page?: number, $sizeEventos?: number, $sizeActividades?: number, $user?: string, $extendExpiration?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<KoguiSearch>>;
    public getKoguiDashboard(searchId: string, xFcmtoken?: string, $page?: number, $sizeEventos?: number, $sizeActividades?: number, $user?: string, $extendExpiration?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<KoguiSearch>>;
    public getKoguiDashboard(searchId: string, xFcmtoken?: string, $page?: number, $sizeEventos?: number, $sizeActividades?: number, $user?: string, $extendExpiration?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (searchId === null || searchId === undefined) {
            throw new Error('Required parameter searchId was null or undefined when calling getKoguiDashboard.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sizeEventos !== undefined && $sizeEventos !== null) {
            queryParameters = queryParameters.set('$size-eventos', <any>$sizeEventos);
        }
        if ($sizeActividades !== undefined && $sizeActividades !== null) {
            queryParameters = queryParameters.set('$size-actividades', <any>$sizeActividades);
        }
        if ($user !== undefined && $user !== null) {
            queryParameters = queryParameters.set('$user', <any>$user);
        }
        if ($extendExpiration !== undefined && $extendExpiration !== null) {
            queryParameters = queryParameters.set('$extend-expiration', <any>$extendExpiration);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<KoguiSearch>(`${this.configuration.basePath}/kogui/dashboard/${encodeURIComponent(String(searchId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la empresas
     * Obtiene la empresa
     * @param empresaId Especifica la empresaid.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiEmpresaById(empresaId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<KoguiEmpresa>;
    public getKoguiEmpresaById(empresaId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<KoguiEmpresa>>;
    public getKoguiEmpresaById(empresaId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<KoguiEmpresa>>;
    public getKoguiEmpresaById(empresaId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getKoguiEmpresaById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<KoguiEmpresa>(`${this.configuration.basePath}/kogui/empresas/${encodeURIComponent(String(empresaId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de empresas
     * Obtiene la lista de empresas
     * @param xFcmtoken 
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiEmpresas(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<KoguiEmpresa>>;
    public getKoguiEmpresas(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<KoguiEmpresa>>>;
    public getKoguiEmpresas(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<KoguiEmpresa>>>;
    public getKoguiEmpresas(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<KoguiEmpresa>>(`${this.configuration.basePath}/kogui/empresas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene una foto de empresa identificada por id.
     * Obtiene una foto de evento del id dado.
     * @param empresaId Especifica la empresaid.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiEmpresasByIdLogo(empresaId: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getKoguiEmpresasByIdLogo(empresaId: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getKoguiEmpresasByIdLogo(empresaId: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getKoguiEmpresasByIdLogo(empresaId: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getKoguiEmpresasByIdLogo.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'image/_*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/kogui/empresas/${encodeURIComponent(String(empresaId))}/logo`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Detalle de un evento
     * EL detalle de un evento.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiEventoById(eventoId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<KoguiEvento>;
    public getKoguiEventoById(eventoId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<KoguiEvento>>;
    public getKoguiEventoById(eventoId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<KoguiEvento>>;
    public getKoguiEventoById(eventoId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling getKoguiEventoById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<KoguiEvento>(`${this.configuration.basePath}/kogui/eventos/${encodeURIComponent(String(eventoId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de eventos paginadas. por defecto se ordenan en orden descendiente de creacion.
     * Al obtener las eventosd puede especificar una paginacion y orden para mostrarlo.
     * @param xFcmtoken 
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param estado Especifica el estado a buscar.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiEventos(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoEvento, observe?: 'body', reportProgress?: boolean): Observable<Array<KoguiEvento>>;
    public getKoguiEventos(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoEvento, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<KoguiEvento>>>;
    public getKoguiEventos(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoEvento, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<KoguiEvento>>>;
    public getKoguiEventos(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoEvento, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }
        if (estado !== undefined && estado !== null) {
            queryParameters = queryParameters.set('estado', <any>estado);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<KoguiEvento>>(`${this.configuration.basePath}/kogui/eventos/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene una foto de evento identificada por id.
     * Obtiene una foto de evento del id dado.
     * @param fotoId El id de la foto.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiEventosFotosById(fotoId: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getKoguiEventosFotosById(fotoId: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getKoguiEventosFotosById(fotoId: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getKoguiEventosFotosById(fotoId: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (fotoId === null || fotoId === undefined) {
            throw new Error('Required parameter fotoId was null or undefined when calling getKoguiEventosFotosById.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'image/_*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/kogui/eventos/fotos/${encodeURIComponent(String(fotoId))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista los codigos telefonicos por pais.
     * Lista los codigos telefonicos por pais.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPhonesCountry(xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PhoneCountryInfo>>;
    public getPhonesCountry(xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PhoneCountryInfo>>>;
    public getPhonesCountry(xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PhoneCountryInfo>>>;
    public getPhonesCountry(xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<PhoneCountryInfo>>(`${this.configuration.basePath}/kogui/phones/country/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verifica si el usuario tiene una reserva PRE, asociada a ese usuario.
     * Verifica reserva PRE, para una entidad
     * @param usuario El usuario de kogui.
     * @param type El tipo de entidad que se puede reservar
     * @param targetRef El id del evento o de la actividad.
     * @param xFcmtoken 
     * @param programacion La fecha de la programacion en el caso que sea una actividad.
     * @param estado El estado de la reserva que se quiere verififcar
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public headKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, xFcmtoken?: string, programacion?: string, estado?: EstadoReserva, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public headKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, xFcmtoken?: string, programacion?: string, estado?: EstadoReserva, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public headKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, xFcmtoken?: string, programacion?: string, estado?: EstadoReserva, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public headKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, xFcmtoken?: string, programacion?: string, estado?: EstadoReserva, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling headKoguiUsuariosByIdReservas.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling headKoguiUsuariosByIdReservas.');
        }
        if (targetRef === null || targetRef === undefined) {
            throw new Error('Required parameter targetRef was null or undefined when calling headKoguiUsuariosByIdReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }
        if (targetRef !== undefined && targetRef !== null) {
            queryParameters = queryParameters.set('target-ref', <any>targetRef);
        }
        if (programacion !== undefined && programacion !== null) {
            queryParameters = queryParameters.set('programacion', <any>programacion);
        }
        if (estado !== undefined && estado !== null) {
            queryParameters = queryParameters.set('estado', <any>estado);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.head<any>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param usuario El usuario de kogui.
     * @param reservaId El id de una reserva asociado al usuario.
     * @param xFcmtoken 
     * @param findReserva Indique que se devuelva la reserva modificada.
     * @param koguiReservaPatch Solicitud de Patch sobre la reserva.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, findReserva?: string, koguiReservaPatch?: KoguiReservaPatch, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public patchKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, findReserva?: string, koguiReservaPatch?: KoguiReservaPatch, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public patchKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, findReserva?: string, koguiReservaPatch?: KoguiReservaPatch, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public patchKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, findReserva?: string, koguiReservaPatch?: KoguiReservaPatch, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling patchKoguiByUsuarioReservasById.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling patchKoguiByUsuarioReservasById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (findReserva !== undefined && findReserva !== null) {
            queryParameters = queryParameters.set('find-reserva', <any>findReserva);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<Reserva>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/${encodeURIComponent(String(reservaId))}`,
            koguiReservaPatch,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una nueva entrada en la lista de favoritos.
     * Create Favorito
     * @param usuario El usuario de kogui.
     * @param type El tipo del favorito
     * @param id El id del favorito
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Favorite>;
    public postKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Favorite>>;
    public postKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Favorite>>;
    public postKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling postKoguiByUsuarioFavoritosByTypeById.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling postKoguiByUsuarioFavoritosByTypeById.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling postKoguiByUsuarioFavoritosByTypeById.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.post<Favorite>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/${encodeURIComponent(String(type))}/${encodeURIComponent(String(id))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea un nuevo search para el usuario que esta loggeado.
     * @param koguiSearchRequest Reserva Request
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postKoguiDashboard(koguiSearchRequest: KoguiSearchRequest, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<KoguiSearchCreated>;
    public postKoguiDashboard(koguiSearchRequest: KoguiSearchRequest, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<KoguiSearchCreated>>;
    public postKoguiDashboard(koguiSearchRequest: KoguiSearchRequest, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<KoguiSearchCreated>>;
    public postKoguiDashboard(koguiSearchRequest: KoguiSearchRequest, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (koguiSearchRequest === null || koguiSearchRequest === undefined) {
            throw new Error('Required parameter koguiSearchRequest was null or undefined when calling postKoguiDashboard.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<KoguiSearchCreated>(`${this.configuration.basePath}/kogui/dashboard/`,
            koguiSearchRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una nueva reserva asociado a la actividad o al evento.
     * Aparte el cupo reservando par la actividad o evento.
     * @param usuario El usuario de kogui.
     * @param type El tipo de entidad que se puede reservar
     * @param targetRef El id del evento o de la actividad.
     * @param reservaBase Reserva Request
     * @param xFcmtoken 
     * @param programacion La fecha de la programacion en el caso que sea una actividad.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, reservaBase: ReservaBase, xFcmtoken?: string, programacion?: string, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public postKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, reservaBase: ReservaBase, xFcmtoken?: string, programacion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public postKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, reservaBase: ReservaBase, xFcmtoken?: string, programacion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public postKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, reservaBase: ReservaBase, xFcmtoken?: string, programacion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling postKoguiUsuariosByIdReservas.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling postKoguiUsuariosByIdReservas.');
        }
        if (targetRef === null || targetRef === undefined) {
            throw new Error('Required parameter targetRef was null or undefined when calling postKoguiUsuariosByIdReservas.');
        }
        if (reservaBase === null || reservaBase === undefined) {
            throw new Error('Required parameter reservaBase was null or undefined when calling postKoguiUsuariosByIdReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }
        if (targetRef !== undefined && targetRef !== null) {
            queryParameters = queryParameters.set('target-ref', <any>targetRef);
        }
        if (programacion !== undefined && programacion !== null) {
            queryParameters = queryParameters.set('programacion', <any>programacion);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Reserva>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/`,
            reservaBase,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verifica si el usuario tiene una reserva PRE, asociada a ese usuario.
     * Verifica reserva PRE, para una entidad-
     * @param usuario El usuario de kogui.
     * @param type El tipo de entidad que se puede reservar
     * @param targetId El id de una entidad del cual se esta reservando.
     * @param xFcmtoken 
     * @param programacion La fecha de la programacion.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postReservaExistsForTypeAndRefId(usuario: string, type: TipoReserva, targetId: string, xFcmtoken?: string, programacion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postReservaExistsForTypeAndRefId(usuario: string, type: TipoReserva, targetId: string, xFcmtoken?: string, programacion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postReservaExistsForTypeAndRefId(usuario: string, type: TipoReserva, targetId: string, xFcmtoken?: string, programacion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postReservaExistsForTypeAndRefId(usuario: string, type: TipoReserva, targetId: string, xFcmtoken?: string, programacion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling postReservaExistsForTypeAndRefId.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling postReservaExistsForTypeAndRefId.');
        }
        if (targetId === null || targetId === undefined) {
            throw new Error('Required parameter targetId was null or undefined when calling postReservaExistsForTypeAndRefId.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (programacion !== undefined && programacion !== null) {
            queryParameters = queryParameters.set('programacion', <any>programacion);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.post<any>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/exists/${encodeURIComponent(String(type))}/${encodeURIComponent(String(targetId))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una opinion de un usuario sobre un destino.
     * Crea una opinion de un usuario sobre un destino.
     * @param usuario El usuario de kogui.
     * @param tipoDestino El usuario de kogui.
     * @param destino El id del destino.
     * @param opinionNew Opinion Request
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, opinionNew: OpinionNew, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Opinion>;
    public putKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, opinionNew: OpinionNew, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Opinion>>;
    public putKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, opinionNew: OpinionNew, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Opinion>>;
    public putKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, opinionNew: OpinionNew, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling putKoguiByUsuarioByDestino.');
        }
        if (tipoDestino === null || tipoDestino === undefined) {
            throw new Error('Required parameter tipoDestino was null or undefined when calling putKoguiByUsuarioByDestino.');
        }
        if (destino === null || destino === undefined) {
            throw new Error('Required parameter destino was null or undefined when calling putKoguiByUsuarioByDestino.');
        }
        if (opinionNew === null || opinionNew === undefined) {
            throw new Error('Required parameter opinionNew was null or undefined when calling putKoguiByUsuarioByDestino.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Opinion>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/opiniones/${encodeURIComponent(String(tipoDestino))}/${encodeURIComponent(String(destino))}`,
            opinionNew,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
